// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyACUdbpe9_OsEAF1MevoTvia_P8WFjO9Po",
  authDomain: "nexgami-d9e01.firebaseapp.com",
  projectId: "nexgami-d9e01",
  storageBucket: "nexgami-d9e01.appspot.com",
  messagingSenderId: "310675491806",
  appId: "1:310675491806:web:d234ee4dca94f0e9dfab4f",
  measurementId: "G-GYN0BMFN1H"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
export default firebaseApp;